'use strict';
module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./~/postcss/~/supports-color/browser.js
// module id = 1604
// module chunks = 6